import axios from 'axios';
import { showAlert } from './alert';
import { addError } from './errors';
import { hideLoader, showLoader } from './loader';

const TOPIC_SERVICE = 'topics';

const POST_SERVICE = 'posts';

const COMMENT_SERVICE = 'comments';

const POST_LIKE_SERVICE = 'posts/likes'

const SINGLE_POST_LIKE_SERVICE = 'posts/like'

const POST_FLAG_SERVICE = 'posts/flags'

const getService = (type) => {
	let service;
	if(type === 'topic') {
		service = TOPIC_SERVICE;
	}
	if(type === 'post') {
		service = POST_SERVICE;
	}
	if(type === 'comment') {
		service = COMMENT_SERVICE;
	}
	if(type === 'post_like') {
		service = POST_LIKE_SERVICE;
	}
	if(type === 'post__like') {
		service = SINGLE_POST_LIKE_SERVICE;
	}
	if(type === 'post_flag') {
		service = POST_FLAG_SERVICE;
	}
	return service;
}

export const createItem = (type, parentData) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		let service = getService(type);
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.post(service, parentData)
			.then(res => {
				dispatch(hideLoader());
				response(res);
			})
			.catch(function (err) {
				console.warn(err);
				dispatch(hideLoader());
				if (err.response)
					dispatch(
						showAlert(
							err.response.data.error.message ||
								'Something went wrong. Please try again.',
							true
						)
					);
			});
	});
};

export const patchItem = (type, parentData) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		let service = getService(type);
		if (!parentData.id) {
			return console.error('Cannot edit item without id.');
		}
		return axios
			.patch(service + `/${parentData.id}`, parentData)
			.then(res => {
				dispatch(hideLoader());
				response(res);
			})
			.catch(function (err) {
				dispatch(hideLoader());
				if (err.response)
					dispatch(
						showAlert(
							err.response.data.error.message ||
								'Something went wrong. Please try again.',
							true
						)
					);
			});
	});
};


export const fetchList = (itemObj) => dispatch => {
	if (itemObj.skip === 0) {
		dispatch(showLoader());
	}
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	let service = getService(itemObj.type);
	delete itemObj.type;
	return new Promise((response, reject) => {
	    return axios
            .get(service, {
                params: itemObj
			})
            .then(res => {
				if (itemObj.postType !== 'intro') {
                	dispatch(hideLoader());
				}
			    response(res.data.data);
            }).catch(function (err) {
                dispatch(hideLoader());
                if (err.response)
                    dispatch(
                        showAlert(
                            err.response.data.error.message ||
                                'Something went wrong. Please try again.',
                            true
                        )
                    );
            });
    });
};


export const fetchInfo = (_id, type) => dispatch => {
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	let service = getService(type);
    return new Promise((response, reject) => {
        return axios
            .get(`${service}/${_id}`, {
                params: {}})
            .then(res => {
                dispatch(hideLoader());
			    response(res.data);
            }).catch(function (err) {
                dispatch(hideLoader());
                if (err.response)
                    dispatch(
                        showAlert(
                            err.response.data.error.message ||
                                'Something went wrong. Please try again.',
                            true
                        )
                    );
            });
    });
};

export const fetchDefaultTopicBySection = (section, creatorId) => dispatch => {
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
    return new Promise((response, reject) => {
		let url = `${TOPIC_SERVICE}/section/${section}`;
		let param = {}
		if (section === 'channel') {
			param['creatorId'] = creatorId;
		}
	   return axios
            .get(`${TOPIC_SERVICE}/section/${section}`, {
                params: param })
            .then(res => {
                dispatch(hideLoader());
			    response(res.data);
            }).catch(function (err) {
                dispatch(hideLoader());
                if (err.response)
                    dispatch(
                        showAlert(
                            err.response.data.error.message ||
                                'Something went wrong. Please try again.',
                            true
                        )
                    );
            });
    });
};

export const fetchTranscodedItem = (_id, type, ids) => dispatch => {
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	let service = getService(type);
	if (service === 'topics') {
		service = `${service}/transcodedItems`
	} else {
		service = `${service}/transcodedItems/${_id}`;
	}
    return new Promise((response, reject) => {
        return axios
            .get(service, {
                params: {
					_ids: ids
				}})
            .then(res => {
			    response(res.data);
            }).catch(function (err) {
            });
    });
};

export const deleteItem = (id, type) => dispatch => {
	if (!id) {
		console.error('item does not have id');
		return false;
	}
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	let service = getService(type);
	return axios
		.delete(`${service}/${id}`)
		.then(res => {
			dispatch(hideLoader());
			dispatch(showAlert(`This ${type} deleted successfully.`));
			return res;
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
		});
};




// WEBPACK FOOTER //
// ./src/store/actions/community.js